import ExamPage from "./exam.page";

export default ExamPage;
